import { render, staticRenderFns } from "./BasePhotoCard.vue?vue&type=template&id=27047475&"
import script from "./BasePhotoCard.vue?vue&type=script&lang=js&"
export * from "./BasePhotoCard.vue?vue&type=script&lang=js&"
import style0 from "./BasePhotoCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports